import { useState, useEffect } from "react";
import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";
import { Link } from "react-router-dom";

import { CountryService } from "../../services/CountryService";
import BibliographyTable from "../Common/BibliographyTable";

const HonoraryBibliography = () => {
  const [honoraryBibliography, setHonoraryBibliography] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService
      .getHonoraryBibliography(0)
      .then((data) => setHonoraryBibliography(data));
  }, []);

  return (
    <div>
      {AddPageHeader("Honorary bibliography")}
      <div className="reduce-width">
        <Divider align="center">
          <h1>Honorary bibliography</h1>
        </Divider>
        <div className="privacy-terms">
          This page features publications on honorary consuls extracted from{" "}
          <Link
            to="/the-consular-bibliography"
            style={{
              color: "black",
              fontWeight: "bold",
            }}
          >
            The Consular Bibliography
          </Link>
          . The Bibliography references a variety of formats, such as books,
          book chapters, book reviews, case studies, conference papers, essays,
          interviews, journal articles, magazine articles, op-eds, opinion
          pieces, policy analyses, preprints, reports, research papers,
          technical documents, and theses. The Bibliography is updated and
          published each month as part of a work in progress. Have a publication
          to reference or corrections to suggest? Please feel free to{" "}
          <Link
            to="/contact"
            style={{
              color: "black",
              fontWeight: "bold",
            }}
          >
            contact
          </Link>{" "}
          the Center.
        </div>
        <br />
        <div
          className="flex h-full gap-3 justify-content-center"
          style={{ height: "100%" }}
        >
          <a
            href="https://doi.org/10.5281/zenodo.15614106"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontWeight: "bold",
              width: "220px",
              maxWidth: "90%",
              textDecoration: "none",
            }}
          >
            <div className="text-center p-3 border-round-sm bg-primary h-full flex flex-column justify-content-center">
              <div>Access the most recent edition</div>
            </div>
          </a>
        </div>
        <BibliographyTable
          data={honoraryBibliography}
          longDescription
          searchEnabled={true}
        />
      </div>
    </div>
  );
};

export default HonoraryBibliography;
